<form class="ivr-actions" [formGroup]="form">

  <div
    class="ivr-action"
    *ngFor="let ivr of form.controls; let i = index"
    [formGroupName]="i"
  >

    <div class="inputs-wrapper">

      <div class="key-wrapper">
        <div class="key">
          {{ ivr.value.digit }}
        </div>
      </div>

      <div class="action-wrapper">
        <mat-select
          class="action-select"
          [placeholder]="'IVR.SELECT_ACTION' | translate"
          [disableRipple]="false"
          formControlName="action"
          required
        >
          <mat-option
            *ngFor="let action of ['TRANSFER', 'SELECT_INBOUND']"
            [value]="action"
          >
            {{ 'IVR.' + action | translate }}
          </mat-option>
        </mat-select>
      </div>

      <label
        *ngIf="ivr.get('action').value === 'SELECT_INBOUND'"
        class="choose-number-wrapper"
      >
        <span class="choose-number-label">
          {{ 'IVR.CHOOSE_NUMBER' | translate }}
        </span>
        <div class="choose-number-select input-error">
          <mat-select
            [placeholder]="'PHONE_NUMBER' | translate"
            [disableRipple]="false"
            formControlName="msisdn"
          >
            <mat-option
              *ngFor="let number of _msisdns"
              [value]="number.msisdn"
            >
              <cc-msisdn [msisdn]="number"></cc-msisdn>
            </mat-option>
          </mat-select>
          <cc-input-errors
            [form]="form"
            [inputName]="i + '.msisdn'"
            [errors]="[{'required': 'ERRORS.REQUIRED'}]"
          ></cc-input-errors>
        </div>
      </label>

      <label
        *ngIf="ivr.get('action').value === 'TRANSFER'"
        class="type-number-wrapper"
      >
        <span class="type-number-label">
          {{ 'IVR.WRITE_NUMBER' | translate }}
        </span>
        <div
          class="type-number-input input-error"
        >
          <cc-intl-phone-number-input formControlName="msisdn"></cc-intl-phone-number-input>
          <cc-input-errors
            [form]="form"
            [inputName]="i + '.msisdn'"
            [errors]="[{'phone': 'ERRORS.PHONE'}, {'required': 'ERRORS.REQUIRED'}]"
          ></cc-input-errors>
        </div>
      </label>

      <label class="type-label-wrapper">
        <span class="type-label-label" translate>IVR.MENU_LABEL</span>
        <div class="type-label-input input-error">
          <input formControlName="label" class="form-control" placeholder="{{ 'IVR.MENU_LABEL' | translate }}"/>
          <cc-input-errors
            [form]="form"
            [inputName]="i + '.label'"
            [errors]="[{'required': 'ERRORS.REQUIRED'}]"
          ></cc-input-errors>
        </div>
      </label>
    </div>

    <div (click)="removeAt(i)" class="delete-icon-wrapper" *ngIf="i > 0" layout>
      <img src="/assets/img/channels/trash.png" alt="">
    </div>

  </div>

</form>
